import React from "react";

import Iframe from "../../_components/iframe/iframe";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

import "./additional-instructions.styles.css";

const AdditionalInstructions = ({
  instructionUrl,
  closeAdditionalInstruction,
}) => {
  return (
    <div className="additional-instructions">
      <div className="close-button-wrapper">
        <button
          className="btn btn-primary text-center"
          onClick={()=>closeAdditionalInstruction(false)}
        >
          next <FontAwesomeIcon icon={faArrowRight} />
        </button>
      </div>
      <Iframe url={instructionUrl} />
    </div>
  );
};

export default AdditionalInstructions;
